define('viewModels/privileged/composer/forms/QualityFormsMain',[
    'lib/knockout',
    'viewModels/ViewModel',
    'viewModels/SwitchedView',
    'viewModels/privileged/composer/forms/QualityFormsList',
    'viewModels/privileged/composer/forms/EvaluationFormEditor',
    'viewModels/privileged/composer/forms/EmbeddedQualityFormEditor'
], function (
    ko,
    ViewModel,
    SwitchedViewViewModel,
    QualityFormsListViewModel,
    EvaluationFormEditorViewModel,
    EmbeddedQualityFormEditor
) {
    "use strict";

    var QualityFormsMainViewModel =  ViewModel.extend(function () {
        var self = this;

        self.subViews = self.subView(SwitchedViewViewModel, {
            "qualityFormsList": QualityFormsListViewModel,
            "evaluationFormEditor": EvaluationFormEditorViewModel,
            "embeddedQualityFormEditor": EmbeddedQualityFormEditor
        });
    });

    return QualityFormsMainViewModel;
});
